export default {
  NEW: 'NEW',
  MID: 'MID',
} as const
